export default __webpack_public_path__ + "6c8063be3afa1d95c902398f3d913aa3.svg";